export default __webpack_public_path__ + "static/media/b-corp-regener-m.e8bd8182.png";